module.exports = __webpack_public_path__ + "img/yxtitle.12e390d7.png";